import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('snippets');

const snippetsRoutes = [
  {
    path: '/snippets',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: '',
        name: 'snippets',
        props: true,
        meta: { feature: 'snippets' },
        component: loadView('SnippetsPage'),
      },
      {
        path: ':folderId/create',
        name: 'snippets-create',
        props: true,
        meta: { feature: 'snippets' },
        component: loadView('SnippetForm'),
      },
      {
        path: ':folderId/:id',
        name: 'snippet-edit',
        props: true,
        meta: { feature: 'snippets' },
        component: loadView('SnippetForm'),
      },
    ],
  },
];

export default snippetsRoutes;
